export type ToolRole = 'viewer' | 'editor';

export interface UserTool {
  key: string;
  title: string;
  role: ToolRole;
}

export enum UserAction {
    Backgrounds = 'backgrounds',
    Characters = 'characters',
    CharacterMemories = 'character-memories',
    ChoiceMemory = 'choice-memory',
    MemorySpeakers = 'memory-speakers',
    Achievements = 'achievements',
    Videos = 'videos',
    Audios = 'audios',
    HubStep = 'hub-step',
    ABTest = 'ab-test',
    SocialLinks = 'social-links', // new action for controlling Social Links section access
    HideSavePoints = 'hide-save-points',
    RenpyUpload = 'renpy-upload',
    LastingMemory = 'lasting-memory',
    BulkCharacterImport = 'bulk-character-import',
}

export const getActionLabelByAction = (action: UserAction) => {
  switch (action) {
    case UserAction.Backgrounds:
      return 'Backgrounds';
    case UserAction.Characters:
      return 'Character Skins';
    case UserAction.CharacterMemories:
      return 'Character Memories';
    case UserAction.ChoiceMemory:
      return 'Choice Memory';
    case UserAction.MemorySpeakers:
      return 'Memory Speakers';
    case UserAction.Achievements:
      return 'Achievements';
    case UserAction.Videos:
      return 'Videos';
    case UserAction.Audios:
      return 'Audios';
    case UserAction.HubStep:
      return 'Hub Step';
    case UserAction.ABTest:
      return 'A/B Test';
    case UserAction.SocialLinks:
      return 'Social Links';
    case UserAction.HideSavePoints:
      return 'Hide Save Points';
    case UserAction.RenpyUpload:
      return 'RenPy Upload';
    case UserAction.LastingMemory:
      return 'Lasting Memory';
    case UserAction.BulkCharacterImport:
      return 'Bulk Character Import';
    default:
      throw new Error(`Unknown user action: ${action}`);
  }
};

export type UserRole = 'admin' | 'basic_user' | 'user' | 'deactivated' | 'content_viewer';

export interface User {
    'id': number,
    'username': string | null,
    'role': UserRole | string,
    'fullname': string,
    'about': string | null,
    'email': string,
    'email_verified': boolean,
    'contract': boolean,
    'receive_email': boolean,
    'social_media': string,
    'device': string | null,
    'country': string | null,
    'adminShowApproved': boolean,
    'showAnalytic': boolean,
    'isVerified': boolean,
    'allowedFanSignups': number,
    'allowedCreatorSignups': number,
    'privateAppAccess': boolean,
    'firstName': string,
    'lastName': string,
    'accepted': boolean,
    'yourWriting': [],
    'monetized': boolean,
    'latestActivity': string,
    'firstPublishData': string,
    'appAccessDate': null,
    'appWizard': boolean,
    'actions': UserAction[],
    'tools'?: UserTool[],
}

export enum BookUserRole {
    Owner = 'owner',
    Editor = 'editor',
    CoAuthor = 'co-author',
    Exclusive = 'exclusive-access'
}

export interface BookShareUser {
    id: number,
    username?: string,
    fullname?: string,
    firstName?: string,
    lastName?: string,
    book_role: BookUserRole,
    analyticsAccess: boolean,
}

export interface UserDocument {
    acceptRequired: number,
    alias: string,
    body: string,
    createdAt: string,
    hidden: number,
    history_uuid: string,
    id: number,
    summary: string,
    title: string
    updatedAt: string,
    uuid: string,
}
